export const payflipDarkColors = {
  palette_gray: {
    100: '#ffffff',
    80: '#dadae8',
    60: '#a6a6bf',
    40: '#484859',
    10: '#444454',
    5: '#3d3d4c',
    0: '#353542'
  },

  palette_success: {
    100: '#D6F3E2',
    5: '#086343'
  },

  palette_blue: {
    100: '#dadae8',
    5: '#444454',
    0: '#3d3d4c'
  },
  palette_logo: {
    text: '#ffffff'
  }
};
